module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAAAGAQMAAABq/Vs5AAAAA1BMVEUAttpz4w8uAAAAC0lEQVQI12OgEgAAAEgAAV1LcNMAAAAASUVORK5CYII="